(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pb-common-accordion-item"] && !Shopify.designMode) return;
  try {
    (function () {
    const ITEM_SEL = 'details[data-pb-common-accordion-item]';

    function prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function initItem(details) {
      if (!details || details.dataset.init === '1') return;
      details.dataset.init = '1';
      details.classList.add('pb-common-accordion-item--enhanced');

      const summary = details.querySelector('summary');
      const panel = details.querySelector('[data-pb-common-accordion-panel]');
      const inner = details.querySelector('[data-pb-common-accordion-panel-inner]');
      if (!summary || !panel || !inner) return;

      if (prefersReducedMotion()) {
        if (details.open) {
          panel.style.maxHeight = 'none';
        } else {
          panel.style.maxHeight = '0px';
        }
        summary.addEventListener('click', function (e) {
          e.preventDefault();
          details.open = !details.open;
          panel.style.maxHeight = details.open ? 'none' : '0px';
        });
        return;
      }

      function setClosedVisual() {
        panel.style.maxHeight = '0px';
      }

      function setOpenFull() {
        panel.style.maxHeight = 'none';
      }

      if (details.open) {
        setOpenFull();
      } else {
        setClosedVisual();
      }

      function animatePanelToScrollHeight() {
        panel.style.maxHeight = '0px';
        requestAnimationFrame(function () {
          void inner.offsetHeight;
          const target = inner.scrollHeight;
          requestAnimationFrame(function () {
            panel.style.maxHeight = target + 'px';
          });
        });
      }

      function animatePanelToZero() {
        panel.style.maxHeight = inner.scrollHeight + 'px';
        void panel.offsetHeight;
        requestAnimationFrame(function () {
          panel.style.maxHeight = '0px';
        });
      }

      function handleOpenEnd(ev) {
        if (ev.propertyName !== 'max-height') return;
        if (details.open) setOpenFull();
      }

      function handleCloseEnd(ev) {
        if (ev.propertyName !== 'max-height') return;
        details.open = false;
        panel.style.maxHeight = '0px';
      }

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        const opening = !details.open;

        if (opening) {
          details.open = true;
          animatePanelToScrollHeight();
          panel.addEventListener('transitionend', handleOpenEnd, { once: true });
        } else {
          animatePanelToZero();
          panel.addEventListener('transitionend', handleCloseEnd, { once: true });
        }
      });
    }

    function scan(root) {
      root.querySelectorAll(ITEM_SEL).forEach(initItem);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        scan(document);
      });
    } else {
      scan(document);
    }

    document.addEventListener('shopify:section:load', function (ev) {
      if (ev.target && ev.target.querySelector) {
        scan(ev.target);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pb-common-image-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    function initPbCommonImageGallery(root) {
      const track = root.querySelector('[data-pb-gallery-track]');
      const slides = root.querySelectorAll('[data-pb-gallery-slide]');
      const dots = root.querySelectorAll('[data-pb-gallery-dot]');
      const thumbs = root.querySelectorAll('[data-pb-gallery-thumb]');
      const thumbStrip = root.querySelector('[data-pb-gallery-thumbs]');
      const prev = root.querySelector('[data-pb-gallery-prev]');
      const next = root.querySelector('[data-pb-gallery-next]');
      const viewport = root.querySelector('[data-pb-gallery-viewport]');

      if (!track || !slides.length) return;

      let index = 0;
      let touchStartX = 0;
      let touchDeltaX = 0;

      function goTo(i) {
        index = (i + slides.length) % slides.length;
        track.style.transform = 'translate3d(-' + index * 100 + '%, 0, 0)';
        dots.forEach((dot, n) => {
          dot.classList.toggle('is-active', n === index);
          dot.setAttribute('aria-selected', n === index ? 'true' : 'false');
        });
        thumbs.forEach((thumb, n) => {
          thumb.classList.toggle('is-active', n === index);
          thumb.setAttribute('aria-selected', n === index ? 'true' : 'false');
        });
        scrollActiveThumbIntoView();
      }

      function scrollActiveThumbIntoView() {
        if (!thumbStrip) return;
        const active = thumbs[index];
        if (!active) return;
        const pad = 8;
        const left = active.offsetLeft;
        const right = left + active.offsetWidth;
        const viewLeft = thumbStrip.scrollLeft;
        const viewRight = viewLeft + thumbStrip.clientWidth;
        if (left < viewLeft) {
          thumbStrip.scrollTo({ left: Math.max(0, left - pad), behavior: 'smooth' });
        } else if (right > viewRight) {
          thumbStrip.scrollTo({ left: right - thumbStrip.clientWidth + pad, behavior: 'smooth' });
        }
      }

      prev?.addEventListener('click', () => goTo(index - 1));
      next?.addEventListener('click', () => goTo(index + 1));
      dots.forEach((dot, n) => {
        dot.addEventListener('click', () => goTo(n));
      });
      thumbs.forEach((thumb, n) => {
        thumb.addEventListener('click', () => goTo(n));
      });

      if (viewport && slides.length > 1) {
        viewport.addEventListener(
          'keydown',
          (e) => {
            if (e.key === 'ArrowLeft') goTo(index - 1);
            if (e.key === 'ArrowRight') goTo(index + 1);
          },
          false
        );

        viewport.addEventListener(
          'touchstart',
          (e) => {
            touchStartX = e.changedTouches[0].screenX;
            touchDeltaX = 0;
          },
          { passive: true }
        );

        viewport.addEventListener(
          'touchmove',
          (e) => {
            touchDeltaX = e.changedTouches[0].screenX - touchStartX;
          },
          { passive: true }
        );

        viewport.addEventListener(
          'touchend',
          () => {
            if (Math.abs(touchDeltaX) < 40) return;
            if (touchDeltaX < 0) goTo(index + 1);
            else goTo(index - 1);
          },
          { passive: true }
        );
      }

      goTo(0);
    }

    function boot() {
      document.querySelectorAll('[data-pb-gallery]').forEach(initPbCommonImageGallery);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-pb-gallery]').forEach(initPbCommonImageGallery);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pb-lp-product-buybox"] && !Shopify.designMode) return;
  try {
    (function () {
    const buybox = document.querySelector('.pb-lp-product-buybox');
    if (!buybox) return;

    // UI · Subscribe / one-time — DOM selectors
    const PO = {
      root: '[data-pb-lp-product-purchase-option]',
      subscribeRadio: '.pb-lp-product-purchase-option__radio[value="subscribe"]',
      onetimeRadio: '.pb-lp-product-purchase-option__radio[value="one-time"]',
      subscribePlan: '.pb-lp-product-purchase-option__plan--subscribe',
      onetimePlan: '.pb-lp-product-purchase-option__plan--onetime',
      delivery: '[data-pb-lp-product-delivery-dropdown]',
      deliveryFixedWrap: '[data-pb-lp-product-delivery-fixed-wrap]',
      deliverySelectWrap: '[data-pb-lp-product-delivery-select-wrap]',
      deliveryUnavailableWrap: '[data-pb-lp-product-delivery-unavailable-wrap]',
    };

    // Shared — format money
    function formatMoney(cents, formatStr) {
      if (typeof cents !== 'number' || !Number.isFinite(cents)) return '';
      const amount = (Math.round(cents) / 100).toFixed(2);
      const fmt = formatStr || '{{ amount }}';
      return fmt
        .replace(/\{\{\s*amount\s*\}\}/gi, amount)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/gi, String(Math.round(cents / 100)))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/gi, amount.replace('.', ','));
    }

    function parseCents(value, fallback) {
      const n = parseInt(value, 10);
      return Number.isFinite(n) ? n : fallback;
    }

    // Shared — read pricing JSON + selected bundle variants
    function getVariantPricingMap() {
      const el = buybox.querySelector('[data-pb-lp-product-buybox-variant-pricing]');
      if (!el) return {};
      try {
        return JSON.parse(el.textContent.trim());
      } catch (_) {
        return {};
      }
    }

    // UI · Quantity pills — read selected box count
    function getSelectedBoxCount() {
      const sizePicker = buybox.querySelector('[data-pb-common-size-picker]');
      const boxRows = buybox.querySelectorAll('[data-pb-lp-product-buybox-box]');
      const checked = sizePicker?.querySelector('.pb-common-size-picker__input:checked');
      const count = parseInt(checked?.dataset.pbBoxCount, 10);
      if (Number.isFinite(count) && count > 0) return count;

      const visibleRows = buybox.querySelectorAll('[data-pb-lp-product-buybox-box]:not([hidden])');
      return visibleRows.length > 0 ? visibleRows.length : boxRows.length || 1;
    }

    // UI · Bundle dropdowns — visible selects only
    function getVisibleBoxSelects() {
      const maxBoxes = getSelectedBoxCount();
      const selects = [];

      buybox.querySelectorAll('[data-pb-lp-product-buybox-box]').forEach((row) => {
        const index = parseInt(row.dataset.pbLpProductBuyboxBox, 10);
        if (!Number.isFinite(index) || index > maxBoxes) return;

        const select = row.querySelector('.pb-common-product-dropdown__native');
        if (select instanceof HTMLSelectElement && !select.disabled) {
          selects.push(select);
        }
      });

      return selects;
    }

    function getVariantPricing(select, pricingMap) {
      const entry = pricingMap[select.value];
      if (!entry) return { onetime: 0, compare: 0, plans: {}, planIds: {} };

      return {
        onetime: parseCents(entry.onetime, 0),
        compare: parseCents(entry.compare, 0),
        plans: entry.plans && typeof entry.plans === 'object' ? entry.plans : {},
        planIds: entry.planIds && typeof entry.planIds === 'object' ? entry.planIds : {},
      };
    }

    // Shared — one-time tier % from size_option tierMeta
    function getOnetimeDiscountPercent(boxCount) {
      const widget = buybox.querySelector(PO.root);
      if (!widget) return 0;
      const fromTier = parseFloat(
        getTierMeta(getTierCopy(widget), boxCount)?.onetimeDiscountPercent
      );
      return Number.isFinite(fromTier) && fromTier > 0 ? fromTier : 0;
    }

    function applyOnetimeDiscount(cents, boxCount) {
      const discountPercent = getOnetimeDiscountPercent(boxCount);
      if (discountPercent <= 0) return cents;
      return Math.round(cents * (1 - discountPercent / 100));
    }

    function getWelcomeDiscountPercent() {
      return parseFloat(buybox.dataset.pbWelcomeDiscount) || 0;
    }

    function applyWelcomeDiscount(cents) {
      const discountPercent = getWelcomeDiscountPercent();
      if (discountPercent <= 0) return cents;
      return Math.round(cents * (1 - discountPercent / 100));
    }

    // Shared — sum one-time or subscribe price for each visible bundle dropdown.
    function sumBoxTotalsRaw(mode, planKey) {
      const pricingMap = getVariantPricingMap();

      return getVisibleBoxSelects().reduce((sum, select) => {
        const { onetime, plans } = getVariantPricing(select, pricingMap);

        if (mode === 'subscribe') {
          const planCents = plans[planKey];
          return sum + (Number.isFinite(planCents) ? planCents : onetime);
        }

        return sum + onetime;
      }, 0);
    }

    function getMsrpTotalCents() {
      return sumBoxTotalsRaw('onetime');
    }

    function formatPerBoxPrice(cents, formatStr) {
      const price = formatMoney(cents, formatStr);
      return price ? price + '/box' : '';
    }

    function getUnitPriceForVariant(pricing, mode, planKey) {
      if (mode === 'subscribe') {
        const planCents = pricing.plans[planKey];
        return Number.isFinite(planCents) ? planCents : pricing.onetime;
      }

      return pricing.onetime;
    }

    // Shared — highest per-box price among visible picks (drives pill /box labels).
    function getHighestSelectedUnitPrice(mode, planKey) {
      const pricingMap = getVariantPricingMap();
      const selects = getVisibleBoxSelects();
      const resolvedMode = mode || (isSubscribeSelected() ? 'subscribe' : 'onetime');
      const resolvedPlanKey = planKey !== undefined ? planKey : getActivePlanKey();

      if (selects.length) {
        return selects.reduce((max, select) => {
          const pricing = getVariantPricing(select, pricingMap);
          const unit = getUnitPriceForVariant(pricing, resolvedMode, resolvedPlanKey);
          return Math.max(max, unit);
        }, 0);
      }

      const prices = Object.values(pricingMap)
        .map((entry) => {
          const pricing = {
            onetime: parseCents(entry.onetime, 0),
            plans: entry.plans && typeof entry.plans === 'object' ? entry.plans : {},
          };
          return getUnitPriceForVariant(pricing, resolvedMode, resolvedPlanKey);
        })
        .filter((cents) => cents > 0);

      return prices.length ? Math.max(...prices) : 0;
    }

    function getSubscribeDiscountPercent(boxCount) {
      const widget = buybox.querySelector(PO.root);
      if (!widget) return 0;
      const tierMeta = getTierMeta(getTierCopy(widget), boxCount);
      const pct = parseFloat(tierMeta?.subscribeDiscountPercent);
      return Number.isFinite(pct) && pct > 0 ? pct : 0;
    }

    function getSubscribeAdditionalOffCents(tierMeta, msrpCents) {
      const mode = tierMeta?.subscribeAdditionalDiscountMode || 'percent';
      if (mode === 'fixed_amount') {
        const cents = parseInt(tierMeta?.subscribeAdditionalDiscountCents, 10);
        return Number.isFinite(cents) && cents > 0 ? cents : 0;
      }
      const pct = parseFloat(tierMeta?.subscribeAdditionalDiscountPercent);
      if (!Number.isFinite(pct) || pct <= 0) return 0;
      return Math.round(msrpCents * (pct / 100));
    }

    function applySubscribeDiscountFromMsrp(msrpCents, boxCount) {
      const discountPercent = getSubscribeDiscountPercent(boxCount);
      if (discountPercent <= 0) return null;
      return Math.round(msrpCents * (1 - discountPercent / 100));
    }

    function computeSubscribeDisplayTotal(planKey, boxCount) {
      const widget = buybox.querySelector(PO.root);
      const tierMeta = getTierMeta(getTierCopy(widget), boxCount);
      const planSum = sumBoxTotalsRaw('subscribe', planKey);
      const msrp = sumBoxTotalsRaw('onetime');
      const additionalOff = getSubscribeAdditionalOffCents(tierMeta, msrp);

      if (additionalOff > 0) {
        return Math.max(0, planSum - additionalOff);
      }
      const pctDiscounted = applySubscribeDiscountFromMsrp(msrp, boxCount);
      if (pctDiscounted !== null) {
        return pctDiscounted;
      }

      return planSum;
    }

    // UI · Quantity pills — per-box preview for each tier
    function getPerBoxPriceCentsForBoxCount(boxCount) {
      const mode = isSubscribeSelected() ? 'subscribe' : 'onetime';
      const planKey = getActivePlanKey();
      if (mode === 'subscribe') {
        const widget = buybox.querySelector(PO.root);
        const tierMeta = getTierMeta(getTierCopy(widget), boxCount);
        const msrpPerBox = getHighestSelectedUnitPrice('onetime');
        const additionalOffTotal = getSubscribeAdditionalOffCents(tierMeta, msrpPerBox * boxCount);
        if (additionalOffTotal > 0) {
          const planPerBox = getHighestSelectedUnitPrice('subscribe', planKey);
          if (planPerBox > 0 && boxCount > 0) {
            return Math.round((planPerBox * boxCount - additionalOffTotal) / boxCount);
          }
        }
        const subscribePct = getSubscribeDiscountPercent(boxCount);
        if (subscribePct > 0) {
          const msrpPerBox = getHighestSelectedUnitPrice('onetime');
          return Math.round(msrpPerBox * (1 - subscribePct / 100));
        }
      }
      let cents = getHighestSelectedUnitPrice(mode, planKey);
      if (mode === 'onetime') {
        cents = applyOnetimeDiscount(cents, boxCount);
      }
      return cents;
    }

    function getTierCopy(widget) {
      // OTP-only LPs may have no purchase-option widget; never throw — ATC sync runs after welcome banner.
      if (!widget) return {};
      const el = widget.querySelector('[data-pb-lp-product-tier-copy]');
      if (!el) return {};
      try {
        return JSON.parse(el.textContent.trim());
      } catch (_) {
        return {};
      }
    }

    function normalizeGiftTitle(title) {
      return String(title || '')
        .replace(/^\s*free\s+/i, '')
        .trim();
    }

    function escapePromoText(text) {
      return String(text || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    }

    function formatGiftPromoLine(gift) {
      const title = normalizeGiftTitle(gift?.title);
      if (!title) return '';

      let line = '<strong>FREE</strong> ' + escapePromoText(title);
      const price = String(gift?.price || '').replace(/^\$/, '').trim();
      if (price) {
        line += ' ($' + price + ' value)';
      }
      return line;
    }

    function renderTierPromoList(listEl, tierData, mode) {
      if (!listEl) return;

      const itemClass = 'pb-lp-product-purchase-option__benefit';
      const block = tierData?.[mode];
      const html = [];

      if (block?.gifts?.length) {
        block.gifts.forEach((gift) => {
          const line = formatGiftPromoLine(gift);
          if (line) {
            html.push('<li class="' + itemClass + '">' + line + '</li>');
          }
        });
      }

      if (block?.extra?.length) {
        block.extra.forEach((text) => {
          const trimmed = String(text || '').trim();
          if (trimmed) {
            html.push('<li class="' + itemClass + '">' + escapePromoText(trimmed) + '</li>');
          }
        });
      }

      listEl.innerHTML = html.length ? html.join('') : '';
    }

    function getTierMeta(tierCopy, boxCount) {
      const n = parseInt(boxCount, 10);
      if (!Number.isFinite(n) || n < 1) return null;
      return tierCopy?.tierMeta?.['tier' + n] || null;
    }

    function sumGiftBonusCents(gifts) {
      if (!Array.isArray(gifts)) return 0;
      return gifts.reduce((sum, gift) => {
        const price = parseFloat(String(gift?.price || '').replace(/^\$/, '').trim());
        return Number.isFinite(price) ? sum + Math.round(price * 100) : sum;
      }, 0);
    }

    function getPerceivedValueCents(msrpCents, tierMeta, mode) {
      return msrpCents + sumGiftBonusCents(tierMeta?.[mode]?.gifts);
    }

    function syncTierPromoCopy() {
      const widget = buybox.querySelector(PO.root);
      if (!widget) return;

      const boxCount = getSelectedBoxCount();
      const tier = String(boxCount);
      const tierCopy = getTierCopy(widget);
      const tierMeta = getTierMeta(tierCopy, boxCount);

      widget.querySelectorAll('[data-pb-lp-product-freebies-list="subscribe"]').forEach((listEl) => {
        renderTierPromoList(listEl, tierMeta, 'subscribe');
      });

      widget.querySelectorAll('[data-pb-lp-product-freebies-list="onetime"]').forEach((listEl) => {
        renderTierPromoList(listEl, tierMeta, 'onetime');
      });

      const badgeEl = widget.querySelector('[data-pb-lp-product-tier-badge]');
      if (badgeEl) {
        const badgeHtml = tierCopy['badge' + tier];
        if (badgeHtml) {
          badgeEl.innerHTML = badgeHtml;
          badgeEl.hidden = false;
        } else {
          badgeEl.hidden = true;
        }
      }
    }

    // Shared — raw total with discount stack applied.
    function sumBoxTotals(mode, planKey) {
      const boxCount = getSelectedBoxCount();
      if (mode === 'subscribe') {
        return applyWelcomeDiscount(computeSubscribeDisplayTotal(planKey, boxCount));
      }
      const raw = sumBoxTotalsRaw(mode, planKey);
      return applyWelcomeDiscount(applyOnetimeDiscount(raw, boxCount));
    }

    // UI · Welcome banner — savings = price-stack perceived value minus sale total.
    function getTotalSavingsCents(planKey) {
      const mode = isSubscribeSelected() ? 'subscribe' : 'onetime';
      const displayTotal = sumBoxTotals(mode, planKey);
      const widget = buybox.querySelector(PO.root);
      const tierCopy = getTierCopy(widget);
      const tierMeta = getTierMeta(tierCopy, getSelectedBoxCount());
      const perceivedTotal = getPerceivedValueCents(getMsrpTotalCents(), tierMeta, mode);
      return Math.max(0, perceivedTotal - displayTotal);
    }

    function isSubscribeSelected() {
      const widget = buybox.querySelector(PO.root);
      if (!widget) return false;

      const subscribeRadio = widget.querySelector(PO.subscribeRadio);
      return Boolean(subscribeRadio?.checked) && !subscribeRadio?.disabled;
    }

    function getActivePlanKey() {
      const delivery = buybox.querySelector('[data-pb-lp-product-delivery-dropdown]');
      if (delivery instanceof HTMLSelectElement && delivery.value) {
        return delivery.value;
      }

      const widget = buybox.querySelector(PO.root);
      return widget?.dataset.pbLpProductDefaultPlanKey || '';
    }

    function getActiveOrderTotal() {
      const planKey = buybox.querySelector('[data-pb-lp-product-delivery-dropdown]')?.value || '';
      return isSubscribeSelected() ? sumBoxTotals('subscribe', planKey) : sumBoxTotals('onetime');
    }

    // UI · Quantity pills — update /box on each pill
    function syncSizePickerPrices() {
      const sizePicker = buybox.querySelector('[data-pb-common-size-picker]');
      if (!sizePicker) return;

      const pricingMap = getVariantPricingMap();
      if (!pricingMap || !Object.keys(pricingMap).length) return;

      const baseCents = getHighestSelectedUnitPrice(
        isSubscribeSelected() ? 'subscribe' : 'onetime',
        getActivePlanKey()
      );
      if (baseCents < 1) return;

      const format = buybox.dataset.pbMoneyFormat || '';

      sizePicker.querySelectorAll('.pb-common-size-picker__input').forEach((input) => {
        const boxCount = parseInt(input.dataset.pbBoxCount, 10);
        const priceEl = input.closest('.pb-common-size-picker__pill')?.querySelector('[data-pb-size-picker-price]');
        if (!priceEl || !Number.isFinite(boxCount)) return;

        const formatted = formatPerBoxPrice(getPerBoxPriceCentsForBoxCount(boxCount), format);
        if (formatted) priceEl.textContent = formatted;
      });
    }

    // UI · Discrete contents summary — keep ×N badge and auto meta in step with quantity pills
    function syncContentsSummary() {
      const contents = buybox.querySelector('[data-pb-lp-product-contents]');
      if (!contents) return;

      const count = getSelectedBoxCount();
      const qtyWrap = contents.querySelector('[data-pb-lp-product-contents-qty]');
      const qtyValue = contents.querySelector('[data-pb-lp-product-contents-qty-value]');
      if (qtyValue) qtyValue.textContent = String(count);
      if (qtyWrap) qtyWrap.setAttribute('aria-label', count + (count === 1 ? ' box' : ' boxes'));

      // Only rewrite the meta line when it was auto-generated (block meta left blank).
      if (contents.dataset.pbContentsAutoMeta === 'true') {
        const metaEl = contents.querySelector('[data-pb-lp-product-contents-meta]');
        const servings = parseInt(contents.dataset.pbContentsServings, 10);
        if (metaEl && Number.isFinite(servings) && servings > 0) {
          const label = contents.dataset.pbContentsTreatLabel || 'treats';
          metaEl.textContent = servings * count + ' ' + label;
        }
      }
    }

    // UI · Recurring note — update per-box price
    function syncRecurringNote() {
      const note = buybox.querySelector('[data-pb-lp-product-recurring-note]');
      if (!note) return;

      const priceEl = note.querySelector('[data-pb-lp-product-recurring-price]');
      if (!priceEl) return;

      const cents = getPerBoxPriceCentsForBoxCount(getSelectedBoxCount());
      const format = buybox.dataset.pbMoneyFormat || '';
      priceEl.textContent = cents > 0 ? formatMoney(cents, format) : '';
    }

    // UI · Welcome banner — show savings amount (matches price-stack perceived vs sale)
    function syncWelcomeBanner() {
      const banner = buybox.querySelector('[data-pb-lp-product-welcome-offer]');
      if (!banner) return;

      const savingsEl = banner.querySelector('[data-pb-lp-product-welcome-offer-savings]');
      const planKey = getActivePlanKey();
      const totalSavings = getTotalSavingsCents(planKey);

      if (totalSavings < 1) {
        banner.hidden = true;
        return;
      }

      const format = buybox.dataset.pbMoneyFormat || '';
      if (savingsEl) {
        const formatted = formatMoney(totalSavings, format);
        savingsEl.textContent = formatted ? ' ' + formatted : '';
      }
      banner.hidden = false;
    }

    // UI · Subscribe / one-time — disable when bundle pick has no plan
    function variantHasSubscribePlans(pricing) {
      return Object.keys(pricing.plans).length > 0;
    }

    // UI · Subscribe / one-time — every visible bundle pick needs a Recharge plan.
    function selectionSupportsSubscribe() {
      const pricingMap = getVariantPricingMap();
      const selects = getVisibleBoxSelects();

      if (!selects.length) return true;

      return selects.every((select) => variantHasSubscribePlans(getVariantPricing(select, pricingMap)));
    }

    function syncDeliveryUI(widget, available) {
      const fixedWrap = widget.querySelector(PO.deliveryFixedWrap);
      const selectWrap = widget.querySelector(PO.deliverySelectWrap);
      const unavailableWrap = widget.querySelector(PO.deliveryUnavailableWrap);
      const singlePlanOnly = widget.dataset.pbLpProductSinglePlanOnly === 'true';

      if (!available) {
        fixedWrap?.setAttribute('hidden', '');
        selectWrap?.setAttribute('hidden', '');
        unavailableWrap?.removeAttribute('hidden');
        return;
      }

      unavailableWrap?.setAttribute('hidden', '');

      if (singlePlanOnly && fixedWrap) {
        fixedWrap.removeAttribute('hidden');
        selectWrap?.setAttribute('hidden', '');
      } else if (selectWrap) {
        selectWrap.removeAttribute('hidden');
        fixedWrap?.setAttribute('hidden', '');
      }
    }

    // UI · Subscribe / one-time — toggle delivery UI; force one-time if no plan on a pick.
    function updateSubscribeAvailability(widget) {
      const available = selectionSupportsSubscribe();
      const wasUnavailable = widget.dataset.pbLpProductSubscribeWasUnavailable === 'true';
      const subscribeRadio = widget.querySelector(PO.subscribeRadio);
      const onetimeRadio = widget.querySelector(PO.onetimeRadio);
      const subscribePlan = widget.querySelector(PO.subscribePlan);
      let selectionChanged = false;

      subscribePlan?.classList.toggle('is-unavailable', !available);

      if (subscribeRadio instanceof HTMLInputElement) {
        subscribeRadio.disabled = !available;
      }

      if (!available) {
        // Subscribe-only LPs have no one-time fallback — keep subscribe selected and show unavailable UI.
        if (
          subscribeRadio?.checked &&
          onetimeRadio instanceof HTMLInputElement &&
          widget.dataset.pbLpProductHideOnetime !== 'true'
        ) {
          onetimeRadio.checked = true;
          selectionChanged = true;
        }
        widget.dataset.pbLpProductSubscribeWasUnavailable = 'true';
      } else {
        if (wasUnavailable && subscribeRadio instanceof HTMLInputElement) {
          subscribeRadio.checked = true;
          selectionChanged = true;
        }
        widget.dataset.pbLpProductSubscribeWasUnavailable = 'false';
      }

      syncDeliveryUI(widget, available);

      if (selectionChanged) {
        const activeRadio = subscribeRadio?.checked ? subscribeRadio : onetimeRadio;
        activeRadio?.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function updateAllSubscribeAvailability() {
      const widgets = buybox.querySelectorAll(PO.root);
      if (!widgets.length) return;

      widgets.forEach((widget) => {
        updateSubscribeAvailability(widget);
      });
    }

    // UI · ATC button — label, price, add to cart
    function getAtcLabel() {
      const btn = buybox.querySelector('[data-pb-lp-product-atc-btn]');
      if (!btn) return 'Buy now';

      return isSubscribeSelected() ? btn.dataset.pbAtcSubscribe || 'Start now' : btn.dataset.pbAtcOnetime || 'Buy now';
    }

    function paintAtcButton(totalCents) {
      const btn = buybox.querySelector('[data-pb-lp-product-atc-btn]');
      if (!btn) return;

      const base = getAtcLabel();
      const format = buybox.dataset.pbMoneyFormat || '';
      const price = formatMoney(totalCents, format);
      btn.textContent = price ? base + ' — ' + price : base;
    }

    // Shared — optional line item properties:
    // - _offer=<deal sticker> for Gifts in Cart (section setting offer_value)
    // - _offer_type=onetime|subscription for checkout discount apps / gift purchase rules
    function getDealOfferProperties() {
      const value = String(buybox.dataset.pbOfferValue || '').trim();
      if (!value) return null;
      return { _offer: value };
    }

    function getCheckoutOfferProperties(isSubscribe) {
      if (buybox.dataset.pbCheckoutOfferTagEnabled !== 'true') return null;

      const key = String(buybox.dataset.pbCheckoutOfferTagKey || '_offer_type').trim();
      const value = String(
        isSubscribe
          ? buybox.dataset.pbCheckoutOfferTagValueSubscription || 'subscription'
          : buybox.dataset.pbCheckoutOfferTagValueOnetime || 'onetime'
      ).trim();
      if (!key || !value) return null;

      return { [key]: value };
    }

    function applyCheckoutOfferProperties(item, isSubscribe) {
      const properties = Object.assign(
        {},
        getDealOfferProperties() || {},
        getCheckoutOfferProperties(isSubscribe) || {}
      );
      if (Object.keys(properties).length) item.properties = properties;
      return item;
    }

    // UI · ATC button — one cart line per box; merge duplicate variant (+ plan).
    function buildCartItemsFromSelection() {
      const pricingMap = getVariantPricingMap();
      const selects = getVisibleBoxSelects();

      if (!selects.length) {
        return { items: [], error: 'Select a product for each box.' };
      }

      const subscribe = isSubscribeSelected();
      const planKey = getActivePlanKey();
      const agg = {};

      for (const select of selects) {
        const variantId = String(select.value || '').trim();
        if (!variantId) {
          return { items: [], error: 'Select a product for each box.' };
        }

        const idNum = parseInt(variantId, 10);
        if (!Number.isFinite(idNum) || idNum < 1) {
          return { items: [], error: 'Invalid product selection. Refresh and try again.' };
        }

        const { planIds } = getVariantPricing(select, pricingMap);

        if (subscribe) {
          if (!planKey) {
            return { items: [], error: 'Choose a delivery frequency to subscribe.' };
          }

          const planId = parseInt(planIds[planKey], 10);
          if (!Number.isFinite(planId) || planId < 1) {
            return {
              items: [],
              error: 'Subscribe is not available for one or more selected products.',
            };
          }

          const key = variantId + ':' + planId;
          if (!agg[key]) {
            agg[key] = applyCheckoutOfferProperties({ id: idNum, quantity: 0, selling_plan: planId }, true);
          }
          agg[key].quantity += 1;
        } else {
          if (!agg[variantId]) {
            agg[variantId] = applyCheckoutOfferProperties({ id: idNum, quantity: 0 }, false);
          }
          agg[variantId].quantity += 1;
        }
      }

      return { items: Object.values(agg), error: null };
    }

    function getAtcErrorEl() {
      return buybox.querySelector('[data-pb-lp-product-atc-error]');
    }

    function showAtcError(message) {
      const el = getAtcErrorEl();
      if (!el) return;
      el.textContent = message;
      el.hidden = false;
    }

    function clearAtcError() {
      const el = getAtcErrorEl();
      if (!el) return;
      el.textContent = '';
      el.hidden = true;
    }

    function setAtcLoading(isLoading) {
      const btn = buybox.querySelector('[data-pb-lp-product-atc-btn]');
      if (!btn) return;

      btn.disabled = isLoading;
      btn.classList.toggle('is-loading', isLoading);
      btn.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    }

    function getCartAddUrl() {
      const base = window.routes?.cart_add_url || '/cart/add';
      return base.endsWith('.js') ? base : base + '.js';
    }

    function getCartSectionIds() {
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        return drawer.getSectionsToRender().map((section) => section.id);
      }
      return ['cart-drawer', 'cart-icon-bubble'];
    }

    function isCartAddSuccess(result) {
      const data = result?.data;
      if (!result?.ok || !data || data.status) return false;
      if (data.sections) return true;
      if (Array.isArray(data.items) && data.items.length > 0) return true;
      if (data.id) return true;
      return false;
    }

    // UI · ATC button — open cart drawer or fall back to /cart.
    function refreshCartUiAndOpen(btn, addResponse) {
      const cartUpdateName =
        typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate ? PUB_SUB_EVENTS.cartUpdate : 'cart-update';

      const drawer = document.querySelector('cart-drawer');
      const drawerItems = document.querySelector('cart-drawer-items');

      const publishCartUpdate = (cartPayload) => {
        if (typeof publish === 'function' && cartPayload) {
          publish(cartUpdateName, { source: 'pb-lp-product-buybox', cartData: cartPayload });
        }
      };

      if (drawer && addResponse?.sections && typeof drawer.renderContents === 'function') {
        drawer.setActiveElement(btn);
        drawer.renderContents(addResponse);
        publishCartUpdate(addResponse);
        return;
      }

      if (drawerItems && typeof drawerItems.triggerAllUpdate === 'function') {
        if (drawer && typeof drawer.setActiveElement === 'function') {
          drawer.setActiveElement(btn);
        }
        drawerItems.triggerAllUpdate();
        fetch('/cart.js')
          .then((res) => res.json())
          .then(publishCartUpdate)
          .catch(() => {});
        return;
      }

      if (drawer && typeof drawer.open === 'function') {
        drawer.open(btn);
        fetch('/cart.js')
          .then((res) => res.json())
          .then(publishCartUpdate)
          .catch(() => {});
        return;
      }

      window.location.href = window.routes?.cart_url || '/cart';
    }

    function initAtcClick() {
      const btn = buybox.querySelector('[data-pb-lp-product-atc-btn]');
      if (!btn || btn.dataset.pbLpProductAtcBound === 'true') return;

      btn.dataset.pbLpProductAtcBound = 'true';
      btn.addEventListener('click', () => {
        if (btn.disabled) return;

        clearAtcError();
        const built = buildCartItemsFromSelection();
        if (built.error) {
          showAtcError(built.error);
          return;
        }
        if (!built.items.length) {
          showAtcError('Nothing to add. Check your box selections.');
          return;
        }

        setAtcLoading(true);

        const addUrl = getCartAddUrl();
        const sectionIds = getCartSectionIds();

        fetch(addUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({
            items: built.items,
            sections: sectionIds.join(','),
            sections_url: window.location.pathname,
          }),
        })
          .then((res) =>
            res.json().then((data) => ({
              ok: res.ok,
              data,
            }))
          )
          .then((result) => {
            if (!isCartAddSuccess(result)) {
              const data = result.data;
              const errMsg = (data && (data.description || data.message)) || 'Could not add to cart. Please try again.';
              showAtcError(errMsg);
              return;
            }

            refreshCartUiAndOpen(btn, result.data);
          })
          .catch(() => {
            showAtcError('Could not add to cart. Check your connection and try again.');
          })
          .finally(() => {
            setAtcLoading(false);
          });
      });
    }

    function syncAtcButton() {
      paintAtcButton(getActiveOrderTotal());
    }

    // Shared — re-sync all UI on selection change
    function onBuyboxSelectionChange() {
      clearAtcError();
      updateAllSubscribeAvailability();
      syncSizePickerPrices();
      syncContentsSummary();
      syncRecurringNote();
      syncWelcomeBanner();
      syncTierPromoCopy();
      syncAtcButton();
      buybox.dispatchEvent(new CustomEvent('pb-lp-product-buybox-sync', { bubbles: true }));
    }

    const sizePicker = buybox.querySelector('[data-pb-common-size-picker]');
    const boxRows = buybox.querySelectorAll('[data-pb-lp-product-buybox-box]');

    if (sizePicker && boxRows.length) {
      // UI · Quantity pills — show/hide bundle rows by box count
      function syncBoxRows() {
        const count = getSelectedBoxCount();

        boxRows.forEach((row) => {
          const index = parseInt(row.dataset.pbLpProductBuyboxBox, 10);
          const show = Number.isFinite(index) && index <= count;

          row.hidden = !show;
          row.toggleAttribute('hidden', !show);

          const select = row.querySelector('.pb-common-product-dropdown__native');
          const trigger = row.querySelector('.pb-common-product-dropdown__trigger');
          if (select instanceof HTMLSelectElement) {
            select.disabled = !show;
          }
          if (trigger instanceof HTMLButtonElement) {
            trigger.disabled = !show;
          }
        });

        onBuyboxSelectionChange();
      }

      sizePicker.addEventListener('change', syncBoxRows);
      syncBoxRows();
    } else {
      onBuyboxSelectionChange();
    }

    buybox.addEventListener('change', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement) && !(target instanceof HTMLSelectElement)) return;

      const isSizePicker = target.classList.contains('pb-common-size-picker__input');
      const isBoxSelect = target.classList.contains('pb-common-product-dropdown__native');
      const widget = target.closest(PO.root);

      // Size pill change handled by syncBoxRows; box select runs full sync.
      if (isSizePicker || isBoxSelect) {
        if (!isSizePicker) {
          onBuyboxSelectionChange();
        }
        return;
      }

      // Subscribe / one-time or delivery change — prices only (availability already synced).
      if (widget) {
        syncSizePickerPrices();
        syncRecurringNote();
        syncWelcomeBanner();
        syncTierPromoCopy();
        syncAtcButton();
      }
    });

    initAtcClick();

    if (window.PbCommonProductDropdown?.initAll) {
      window.PbCommonProductDropdown.initAll(buybox);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pb-lp-product-purchase-option"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__pbLpProductPurchaseOptionBound) return;
    window.__pbLpProductPurchaseOptionBound = true;

    // UI · DOM selectors
    const SELECTORS = {
      root: '[data-pb-lp-product-purchase-option]',
      buybox: '.pb-lp-product-buybox',
      pricingMap: '[data-pb-lp-product-buybox-variant-pricing]',
      boxRow: '[data-pb-lp-product-buybox-box]',
      sizePicker: '[data-pb-common-size-picker]',
      sizeInput: '.pb-common-size-picker__input',
      boxSelect: '.pb-common-product-dropdown__native',
      delivery: '[data-pb-lp-product-delivery-dropdown]',
      priceUnit: '[data-pb-lp-product-price-unit]',
      subscribeRadio: '.pb-lp-product-purchase-option__radio[value="subscribe"]',
      onetimeRadio: '.pb-lp-product-purchase-option__radio[value="one-time"]',
      subscribePlan: '.pb-lp-product-purchase-option__plan--subscribe',
      onetimePlan: '.pb-lp-product-purchase-option__plan--onetime',
      subscribeValue: '.pb-lp-product-purchase-option__price--subscribe .pb-lp-product-purchase-option__price-value',
      subscribePerceived: '[data-pb-lp-product-subscribe-perceived]',
      subscribePerceivedValue: '[data-pb-lp-product-subscribe-perceived-value]',
      subscribePerTreat: '[data-pb-lp-product-subscribe-per-treat]',
      onetimeValue: '.pb-lp-product-purchase-option__price--onetime .pb-lp-product-purchase-option__price-value',
      onetimePerceived: '[data-pb-lp-product-onetime-perceived]',
      onetimePerceivedValue: '[data-pb-lp-product-onetime-perceived-value]',
      onetimePerTreat: '[data-pb-lp-product-onetime-per-treat]',
      tierCopy: '[data-pb-lp-product-tier-copy]',
      tierBadge: '[data-pb-lp-product-tier-badge]',
      freebiesList: '[data-pb-lp-product-freebies-list]',
    };

    // Shared — format money (format from data-pb-money-format on widget / buybox)
    function formatMoney(cents, formatStr) {
      if (typeof cents !== 'number' || !Number.isFinite(cents)) return '';
      const amount = (Math.round(cents) / 100).toFixed(2);
      if (!formatStr) return amount;
      return formatStr
        .replace(/\{\{\s*amount\s*\}\}/gi, amount)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/gi, String(Math.round(cents / 100)))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/gi, amount.replace('.', ','));
    }

    function parseCents(value, fallback) {
      const n = parseInt(value, 10);
      return Number.isFinite(n) ? n : fallback;
    }

    // Shared — buybox context + visible bundle selects
    function getBuyboxRoot(el) {
      return el.closest(SELECTORS.buybox) || document;
    }

    function getSelectedBoxCount(buybox) {
      const checked = buybox.querySelector(SELECTORS.sizePicker)?.querySelector(`${SELECTORS.sizeInput}:checked`);
      const count = parseInt(checked?.dataset.pbBoxCount, 10);
      if (Number.isFinite(count) && count > 0) return count;

      const visibleRows = buybox.querySelectorAll(`${SELECTORS.boxRow}:not([hidden])`);
      return visibleRows.length > 0 ? visibleRows.length : 1;
    }

    function getVisibleBoxSelects(buybox) {
      const maxBoxes = getSelectedBoxCount(buybox);
      const selects = [];

      buybox.querySelectorAll(SELECTORS.boxRow).forEach((row) => {
        const index = parseInt(row.dataset.pbLpProductBuyboxBox, 10);
        if (!Number.isFinite(index) || index > maxBoxes) return;

        const select = row.querySelector(SELECTORS.boxSelect);
        if (select instanceof HTMLSelectElement && !select.disabled) {
          selects.push(select);
        }
      });

      return selects;
    }

    // Shared — read pricing JSON from buybox
    function getVariantPricingMap(buybox) {
      const el = buybox.querySelector(SELECTORS.pricingMap);
      if (!el) return {};
      try {
        return JSON.parse(el.textContent.trim());
      } catch (_) {
        return {};
      }
    }

    function getVariantPricing(select, pricingMap) {
      const entry = pricingMap[select.value];
      if (!entry) return { onetime: 0, compare: 0, plans: {} };

      return {
        onetime: parseCents(entry.onetime, 0),
        compare: parseCents(entry.compare, 0),
        plans: entry.plans && typeof entry.plans === 'object' ? entry.plans : {},
      };
    }

    // Shared — one-time tier % from size_option tierMeta
    function getOnetimeDiscountPercent(buybox, boxCount) {
      const purchaseWidget =
        buybox && buybox.querySelector ? buybox.querySelector(SELECTORS.root) : null;
      if (!purchaseWidget) return 0;
      const fromTier = parseFloat(
        getTierMeta(getTierCopy(purchaseWidget), boxCount)?.onetimeDiscountPercent
      );
      return Number.isFinite(fromTier) && fromTier > 0 ? fromTier : 0;
    }

    function applyOnetimeDiscount(buybox, cents, boxCount) {
      const discountPercent = getOnetimeDiscountPercent(buybox, boxCount);
      if (discountPercent <= 0) return cents;
      return Math.round(cents * (1 - discountPercent / 100));
    }

    function getWelcomeDiscountPercent(buybox) {
      return parseFloat(buybox.dataset.pbWelcomeDiscount) || 0;
    }

    function applyWelcomeDiscount(buybox, cents) {
      const discountPercent = getWelcomeDiscountPercent(buybox);
      if (discountPercent <= 0) return cents;
      return Math.round(cents * (1 - discountPercent / 100));
    }

    function getSubscribeDiscountPercent(buybox, boxCount) {
      const widget = buybox.querySelector(SELECTORS.root);
      if (!widget) return 0;
      const tierMeta = getTierMeta(getTierCopy(widget), boxCount);
      const pct = parseFloat(tierMeta?.subscribeDiscountPercent);
      return Number.isFinite(pct) && pct > 0 ? pct : 0;
    }

    function getSubscribeAdditionalOffCents(tierMeta, msrpCents) {
      const mode = tierMeta?.subscribeAdditionalDiscountMode || 'percent';
      if (mode === 'fixed_amount') {
        const cents = parseInt(tierMeta?.subscribeAdditionalDiscountCents, 10);
        return Number.isFinite(cents) && cents > 0 ? cents : 0;
      }
      const pct = parseFloat(tierMeta?.subscribeAdditionalDiscountPercent);
      if (!Number.isFinite(pct) || pct <= 0) return 0;
      return Math.round(msrpCents * (pct / 100));
    }

    function applySubscribeDiscount(buybox, msrpCents, boxCount) {
      const discountPercent = getSubscribeDiscountPercent(buybox, boxCount);
      if (discountPercent <= 0) return null;
      return Math.round(msrpCents * (1 - discountPercent / 100));
    }

    function computeSubscribeDisplayTotal(buybox, planKey, boxCount) {
      const widget = buybox.querySelector(SELECTORS.root);
      const tierMeta = getTierMeta(getTierCopy(widget), boxCount);
      const planSum = sumBoxTotalsRaw(buybox, 'subscribe', planKey);
      const msrp = sumBoxTotalsRaw(buybox, 'onetime');
      const additionalOff = getSubscribeAdditionalOffCents(tierMeta, msrp);

      if (additionalOff > 0) {
        return Math.max(0, planSum - additionalOff);
      }
      const pctDiscounted = applySubscribeDiscount(buybox, msrp, boxCount);
      if (pctDiscounted !== null) {
        return pctDiscounted;
      }

      return planSum;
    }

    // Shared — sum one-time or subscribe price for each visible bundle dropdown
    function sumBoxTotalsRaw(buybox, mode, planKey) {
      const pricingMap = getVariantPricingMap(buybox);

      return getVisibleBoxSelects(buybox).reduce((sum, select) => {
        const { onetime, plans } = getVariantPricing(select, pricingMap);

        if (mode === 'subscribe') {
          const planCents = plans[planKey];
          return sum + (Number.isFinite(planCents) ? planCents : onetime);
        }

        return sum + onetime;
      }, 0);
    }

    function sumBoxTotals(buybox, mode, planKey) {
      const boxCount = getSelectedBoxCount(buybox);
      if (mode === 'subscribe') {
        return applyWelcomeDiscount(
          buybox,
          computeSubscribeDisplayTotal(buybox, planKey, boxCount)
        );
      }
      const raw = sumBoxTotalsRaw(buybox, mode, planKey);
      return applyWelcomeDiscount(buybox, applyOnetimeDiscount(buybox, raw, boxCount));
    }

    function getMsrpTotalCents(buybox) {
      return sumBoxTotalsRaw(buybox, 'onetime');
    }

    function sumGiftBonusCents(gifts) {
      if (!Array.isArray(gifts)) return 0;
      return gifts.reduce((sum, gift) => {
        const price = parseFloat(String(gift?.price || '').replace(/^\$/, '').trim());
        return Number.isFinite(price) ? sum + Math.round(price * 100) : sum;
      }, 0);
    }

    function getPerceivedValueCents(msrpCents, tierMeta, mode) {
      return msrpCents + sumGiftBonusCents(tierMeta?.[mode]?.gifts);
    }

    function paintPerceivedRow(wrapEl, valueEl, perceivedCents, displayTotal, format) {
      if (!wrapEl || !valueEl) return;
      if (perceivedCents > displayTotal && perceivedCents > 0) {
        valueEl.textContent = formatMoney(perceivedCents, format);
        wrapEl.hidden = false;
      } else {
        wrapEl.hidden = true;
      }
    }

    function paintPriceStack(widget, mode, displayTotal, perceivedTotal, treatCount, treatLabel, format) {
      const stack = widget.querySelector('.pb-lp-product-purchase-option__price-stack--' + mode);
      if (!stack) return;

      paintPerceivedRow(
        stack.querySelector('[data-pb-lp-product-' + mode + '-perceived]'),
        stack.querySelector('[data-pb-lp-product-' + mode + '-perceived-value]'),
        perceivedTotal,
        displayTotal,
        format
      );

      const valueEl = stack.querySelector('.pb-lp-product-purchase-option__price-value');
      if (valueEl) valueEl.textContent = formatMoney(displayTotal, format);

      stack.querySelectorAll('[data-pb-lp-product-price-unit]').forEach((el) => {
        el.textContent = formatTreatUnit(treatCount, treatLabel);
      });

      paintPerTreat(
        stack.querySelector('[data-pb-lp-product-' + mode + '-per-treat]'),
        displayTotal,
        treatCount,
        format,
        treatLabel
      );
    }

    function getTierCopy(widget) {
      const el = widget.querySelector(SELECTORS.tierCopy);
      if (!el) return {};
      try {
        return JSON.parse(el.textContent.trim());
      } catch (_) {
        return {};
      }
    }

    function normalizeGiftTitle(title) {
      return String(title || '')
        .replace(/^\s*free\s+/i, '')
        .trim();
    }

    function escapePromoText(text) {
      return String(text || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    }

    function formatGiftPromoLine(gift) {
      const title = normalizeGiftTitle(gift?.title);
      if (!title) return '';

      let line = '<strong>FREE</strong> ' + escapePromoText(title);
      const price = String(gift?.price || '').replace(/^\$/, '').trim();
      if (price) {
        line += ' ($' + price + ' value)';
      }
      return line;
    }

    function renderTierPromoList(listEl, tierData, mode) {
      if (!listEl) return;

      const itemClass = 'pb-lp-product-purchase-option__benefit';
      const block = tierData?.[mode];
      const html = [];

      if (block?.gifts?.length) {
        block.gifts.forEach((gift) => {
          const line = formatGiftPromoLine(gift);
          if (line) {
            html.push('<li class="' + itemClass + '">' + line + '</li>');
          }
        });
      }

      if (block?.extra?.length) {
        block.extra.forEach((text) => {
          const trimmed = String(text || '').trim();
          if (trimmed) {
            html.push('<li class="' + itemClass + '">' + escapePromoText(trimmed) + '</li>');
          }
        });
      }

      listEl.innerHTML = html.length ? html.join('') : '';
    }

    function getTierMeta(tierCopy, boxCount) {
      const n = parseInt(boxCount, 10);
      if (!Number.isFinite(n) || n < 1) return null;
      return tierCopy?.tierMeta?.['tier' + n] || null;
    }

    function getTreatDisplayMeta(tierCopy, boxCount, servingsPerBox) {
      const tierMeta = getTierMeta(tierCopy, boxCount);
      const treatLabel = tierMeta?.treatLabel || 'treats';
      let treatCount = parseInt(tierMeta?.treatCount, 10);

      if (!Number.isFinite(treatCount) || treatCount < 1) {
        const fallbackServings = parseInt(servingsPerBox, 10) || 12;
        treatCount = fallbackServings * boxCount;
      }

      return { treatLabel, treatCount };
    }

    function syncTierPromoCopy(widget, buybox) {
      const boxCount = getSelectedBoxCount(buybox);
      const tier = String(boxCount);
      const tierCopy = getTierCopy(widget);
      const tierMeta = getTierMeta(tierCopy, boxCount);

      widget.querySelectorAll('[data-pb-lp-product-freebies-list="subscribe"]').forEach((listEl) => {
        renderTierPromoList(listEl, tierMeta, 'subscribe');
      });

      widget.querySelectorAll('[data-pb-lp-product-freebies-list="onetime"]').forEach((listEl) => {
        renderTierPromoList(listEl, tierMeta, 'onetime');
      });

      const badgeEl = widget.querySelector(SELECTORS.tierBadge);
      if (badgeEl) {
        const badgeHtml = tierCopy['badge' + tier];
        if (badgeHtml) {
          badgeEl.innerHTML = badgeHtml;
          badgeEl.hidden = false;
        } else {
          badgeEl.hidden = true;
        }
      }
    }

    function formatTreatUnit(treatCount, label) {
      if (!label || !treatCount) return '';
      return '/' + treatCount + ' ' + label;
    }

    function paintPerTreat(el, totalCents, treatCount, format, label) {
      if (!el) return;
      const per = treatCount > 0 ? Math.round(totalCents / treatCount) : 0;
      const unit = label || 'treat';
      el.textContent = formatMoney(per, format) + ' per ' + unit;
    }

    function getPlanKey(widget, buybox) {
      const delivery = widget.querySelector(SELECTORS.delivery);
      if (delivery instanceof HTMLSelectElement && delivery.value) {
        return delivery.value;
      }

      return widget.dataset.pbLpProductDefaultPlanKey || '';
    }

    // UI · Subscribe + one-time rows — paint 3-row price stacks
    function updatePrices(widget) {
      const buybox = getBuyboxRoot(widget);
      const format = widget.dataset.pbMoneyFormat || buybox.dataset?.pbMoneyFormat || '';
      const tierCopy = getTierCopy(widget);
      const servingsPerBox = parseInt(tierCopy.servingsPerBox, 10) || parseCents(widget.dataset.pbServings, 12) || 12;
      const boxCount = getSelectedBoxCount(buybox);
      const tierMeta = getTierMeta(tierCopy, boxCount);
      const { treatLabel, treatCount } = getTreatDisplayMeta(tierCopy, boxCount, servingsPerBox);
      const planKey = getPlanKey(widget, buybox);

      const msrpTotal = getMsrpTotalCents(buybox);
      const onetimeTotal = sumBoxTotals(buybox, 'onetime');
      const subscribeTotal = sumBoxTotals(buybox, 'subscribe', planKey);
      const subscribePerceived = getPerceivedValueCents(msrpTotal, tierMeta, 'subscribe');
      const onetimePerceived = getPerceivedValueCents(msrpTotal, tierMeta, 'onetime');

      paintPriceStack(widget, 'subscribe', subscribeTotal, subscribePerceived, treatCount, treatLabel, format);
      paintPriceStack(widget, 'onetime', onetimeTotal, onetimePerceived, treatCount, treatLabel, format);

      syncTierPromoCopy(widget, buybox);
    }

    // UI · Subscribe + one-time rows — selected card highlight
    function setSelectedState(widget) {
      const isSubscribe = Boolean(widget.querySelector(SELECTORS.subscribeRadio)?.checked);
      widget.querySelector(SELECTORS.subscribePlan)?.classList.toggle('is-selected', isSubscribe);
      widget.querySelector(SELECTORS.onetimePlan)?.classList.toggle('is-selected', !isSubscribe);
    }

    // Shared — init widget + listen for buybox quantity/bundle changes
    function initWidget(widget) {
      if (!widget || widget.dataset.init === '1') return;
      widget.dataset.init = '1';

      setSelectedState(widget);
      updatePrices(widget);

      widget.addEventListener('change', (event) => {
        if (!(event.target instanceof HTMLInputElement) && !(event.target instanceof HTMLSelectElement)) return;

        const subscribeRadio = widget.querySelector(SELECTORS.subscribeRadio);
        if (
          event.target instanceof HTMLInputElement &&
          event.target.value === 'subscribe' &&
          subscribeRadio instanceof HTMLInputElement &&
          subscribeRadio.disabled
        ) {
          event.preventDefault();
          // Subscribe-only widgets keep the disabled subscribe radio; no one-time fallback.
          if (widget.dataset.pbLpProductHideOnetime === 'true') return;
          const onetimeRadio = widget.querySelector(SELECTORS.onetimeRadio);
          if (onetimeRadio instanceof HTMLInputElement) {
            onetimeRadio.checked = true;
            onetimeRadio.dispatchEvent(new Event('change', { bubbles: true }));
          }
          return;
        }

        setSelectedState(widget);
        updatePrices(widget);
      });
    }

    document.querySelectorAll(SELECTORS.root).forEach(initWidget);

    // Shared — re-price after buybox finishes box-row sync (size pill) or on flavor change
    document.addEventListener('pb-lp-product-buybox-sync', (event) => {
      const buybox = event.target?.closest?.(SELECTORS.buybox);
      if (!buybox) return;
      buybox.querySelectorAll(SELECTORS.root).forEach(updatePrices);
    });

    document.addEventListener('change', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLSelectElement)) return;
      if (!target.classList.contains('pb-common-product-dropdown__native')) return;

      const buybox = target.closest(SELECTORS.buybox);
      if (!buybox) return;

      buybox.querySelectorAll(SELECTORS.root).forEach(updatePrices);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
